import type { RadarAgent } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarItineraryTypes';
import type { Agent } from '@web-platform/shared-universal-types/src/redux/state/shared/flightSearchResults/agents';

export const mapAgents = (agents: RadarAgent[]): Agent[] =>
  agents.map((agent) => ({
    id: agent.id,
    name: agent.name,
    is_carrier: agent.isCarrier,
    update_status: agent.updateStatus,
    optimised_for_mobile: agent.optimisedForMobile,
    rating: agent.rating,
    feedback_count: agent.feedbackCount,
    partner_messages: agent.partnerMessages,
  }));
